import React from "react"
import { Link } from "gatsby"
import Layout from "../components/Layout"
import { SEO } from "../components/SEO/SEO"
import { PageHero } from "../components/programmatic/PageHero"
import { Breadcrumbs } from "../components/programmatic/Breadcrumbs"
import { ServiceCTA } from "../components/programmatic/ServiceCTA"
import { AuthorBox } from "../components/programmatic/AuthorBox"
import { buildLocalBusiness } from "../components/SEO/schema/localBusiness"
import { buildBreadcrumbList } from "../components/SEO/schema/breadcrumbList"
import comparisons from "../data/comparisons.json"
import type { Comparison } from "../data/types"

const entries = comparisons as Comparison[]

const ComparacoesPage = () => {
  const crumbs = [
    { name: "Início", to: "/" },
    { name: "Comparações", to: "/comparacoes" },
  ]

  const jsonLd = [buildLocalBusiness(), buildBreadcrumbList(crumbs)]

  return (
    <Layout>
      <SEO
        title="Comparações entre Terapias"
        description="Reiki vs meditação, tarô alquímico vs tradicional, florais vs homeopatia e mais. Comparações honestas para te ajudar a escolher."
        canonicalPath="/comparacoes"
        jsonLd={jsonLd}
      />
      <Breadcrumbs crumbs={crumbs} />
      <PageHero
        eyebrow="Comparações"
        headline="Comparações entre Terapias"
        intro="Quando a dúvida é 'qual escolher?', uma comparação honesta ajuda. Aqui comparo terapias que costumam ser confundidas — sem vender uma melhor que a outra."
      />
      <section className="text-gray-700 body-font">
        <div className="container mx-auto px-5 py-10">
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
            {entries.map((entry) => (
              <li key={entry.slug}>
                <Link
                  to={`/comparacoes/${entry.slug}`}
                  className="block bg-purple-50 hover:bg-purple-100 rounded p-5 transition-colors"
                >
                  <h2 className="text-lg font-medium text-gray-900 mb-2">
                    {entry.aLabel} vs {entry.bLabel}
                  </h2>
                  <p className="text-sm text-gray-600 line-clamp-3">
                    {entry.summary}
                  </p>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <ServiceCTA prefill="Olá Gabriela, vim das comparações do site e gostaria de saber qual atendimento faz mais sentido para mim." />
      <AuthorBox />
    </Layout>
  )
}

export default ComparacoesPage
